//@ts-check

class LineDrawer {
    /**
     * 
     * @param {string} wrapperDivId - Div in relative position where the points are going to get drawn to
     * @param {Number} strokeWidth - Width of the line
     * @param {string} color - Css color for the line
     * @param {Number} snapAngle - Angle in degrees for each line snapping
     */
    constructor(wrapperDivId, strokeWidth, color = "#c8102e", snapAngle = 45) {
        this.strokeColor = color;
        this.strokeWidth = strokeWidth;
        this.SnapAngle = snapAngle;
        this.wrapperDiv = /**@type {HTMLDivElement}*/(document.getElementById(wrapperDivId));
        /**@type {Line[]} */
        this.lines = []
        this.activeLine = null;
        
        const outputEl = document.createElement("div");
        outputEl.style.backgroundColor = "rgb(0 0 0 / 50%)";
        outputEl.style.padding = " 10px 10px 10px 10px";
        outputEl.style.borderRadius = "0.25rem";
        outputEl.style.position = "fixed";
        outputEl.style.top = "80px";
        outputEl.style.right = "10px";
        outputEl.style.zIndex = "100000000";
        outputEl.style.display = "flex";
        outputEl.style.flexDirection = "column";
        outputEl.style.justifyContent = "center";
        outputEl.style.alignItems = "center";

        const copiedP = document.createElement("p");
        copiedP.style.margin = "10px 0 10px 0";
        copiedP.style.color = "white";

        this.outputBtn = document.createElement("button");
        this.outputBtn.onclick = () => {
            navigator.clipboard.writeText(this.getHtmlElementForLines());
            copiedP.innerText = "Html copied successfully";
            setTimeout(() => {
                copiedP.innerText = "";
            }, 3000);
        };
        this.outputBtn.innerHTML = "Copy generated lines HTML";
        this.outputBtn.style.color = "#000";
        this.outputBtn.style.backgroundColor = "#0dcaf0";
        this.outputBtn.style.borderColor = "#0dcaf0";
        this.outputBtn.style.display = "inline-block";
        this.outputBtn.style.fontWeight = "400";
        this.outputBtn.style.lineHeight = "1.5";
        this.outputBtn.style.textAlign = "center";
        this.outputBtn.style.textDecoration = "none";
        this.outputBtn.style.verticalAlign = "middle";
        this.outputBtn.style.cursor = "pointer";
        this.outputBtn.style.userSelect = "none";
        this.outputBtn.style.border = "1px solid";
        this.outputBtn.style.borderRadius = "0.25rem";
        this.outputBtn.style .fontSize= "1rem";
        this.outputBtn.style.padding = "0.375rem 0.75rem";
        this.outputBtn.style.fontFamily = "monospace";

        outputEl.appendChild(this.outputBtn);
        outputEl.appendChild(copiedP);

        document.body.appendChild(outputEl)

        this.wrapperDiv.addEventListener("click", (event) => {
            const wrapperRect = this.wrapperDiv.getBoundingClientRect();
            const relativeCoord = new Vec2d(event.clientX - wrapperRect.x, event.clientY - wrapperRect.y);
            if (!this.activeLine) {
                //Create a line item
                this.activeLine = new Line(this.strokeWidth, this.strokeColor);
                //If the key shift is not held or it's the first line then just put point on cursor
                if (!event.shiftKey || this.lines.length == 0) {
                    //Place it relative to the wrapper
                    this.activeLine.p1 = relativeCoord;
                }
                //If (shift key is pressed and there is at least one preexisting line)
                else if (event.shiftKey && this.lines.length != 0) {
                    let closestPoint = new Vec2d(0, 0);
                    let closestDist = Number.MAX_SAFE_INTEGER;
                    //Get closest point from cursor
                    this.lines.forEach(line => {
                        if (line.p1) {
                            const dist = line.p1?.getDistance(relativeCoord);
                            if (dist < closestDist) {
                                closestDist = dist;
                                closestPoint = line.p1;
                            }
                        }
                        if (line.p2) {
                            const dist = line.p2?.getDistance(relativeCoord);
                            if (dist < closestDist) {
                                closestDist = dist;
                                closestPoint = line.p2;
                            }
                        }
                    });
                    //Start the line at that point
                    this.activeLine.p1 = new Vec2d(closestPoint.x, closestPoint.y);
                }
            }
            else {
                this.lines.push(this.activeLine);
                this.activeLine = null;
                console.log(this.getHtmlElementForLines());

            }
        });
        this.wrapperDiv.addEventListener("mousemove", (event) => this.updateLine(event));
        this.wrapperDiv.addEventListener("touchmove", (event) => this.updateLine(event));
        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape" && this.activeLine) {
                this.activeLine?.htmlElement?.remove();
                this.activeLine = null;
            }
        });
    }

    updateLine(event) {
        const wrapperRect = this.wrapperDiv.getBoundingClientRect();

        //If a line is currently being created
        if (this.activeLine && this.activeLine.p1) {
            const cursorPosInWrapper = new Vec2d(event.clientX - wrapperRect.x, event.clientY - wrapperRect.y);
            //If shift key is held then use snap mode
            if (event.shiftKey) {
                //Determine quadrant of cursor relative to starting point (quadrant divided by circle 45 degree angle around the starting point)
                let degrees = this.getAngleInDegrees(this.activeLine.p1, cursorPosInWrapper);
                //If it's in the negative we want 0-360 degrees not -180-180
                if (degrees < 0) degrees = 360 + degrees;
                //Find closest snap degree
                let snapDegree = Math.round(degrees / this.SnapAngle) * 45;
                if (snapDegree == 360) snapDegree = 0;

                const distanceBetweenP1AndCursor = this.activeLine.p1.getDistance(cursorPosInWrapper);
                const snapPoint = this.findPoint(this.activeLine.p1, snapDegree, distanceBetweenP1AndCursor);
                this.activeLine.p2 = snapPoint;
            }
            else {
                //Place the end of the line to the current position of the cursor relative to the wrapper
                this.activeLine.p2 = cursorPosInWrapper
            }

            const lineElement = this.activeLine.getHtmlElementLine(this.wrapperDiv);
            if (lineElement) {
                //Remove old element from the wrapper if it existed
                this.activeLine.htmlElement?.remove();
                //Add new element
                this.activeLine.htmlElement = lineElement;
                this.wrapperDiv.appendChild(lineElement);
            }
        }
    }

    /**
     * Get the angle in degrees between two points
     * @param {Vec2d} p1 
     * @param {Vec2d} p2 
     * @returns 
     */
    getAngleInDegrees(p1, p2) {
        //Atan2 uses the first point starting from the origin so we have to displace p2 using p1
        const resultingPoint = p2.getSubstractVec(p1);
        //Use atan2 to find the angle in radians and the convert it to degrees
        return (Math.atan2(resultingPoint.y, resultingPoint.x) * 180) / Math.PI;
    }
    /**
     * Get the point at the specific distance and angle from the point given
     * @param {Vec2d} p 
     * @param {Number} angle 
     * @param {Number} distance 
     * @returns 
     */
    findPoint(p, angle, distance) {
        return new Vec2d(
            Math.round(Math.cos(angle * Math.PI / 180) * distance + p.x),
            Math.round(Math.sin(angle * Math.PI / 180) * distance + p.y)
        );
    }

    getHtmlElementForLines() {
        //randomly genereated name so we can have multiple instance of line drawer running on the same page
        const wrapperDivId = uuidv4(); 
        return `<div id="${this.wrapperDiv.id}_lineDrawingWrapper" class="lineDrawingWrapper">\n` +
            this.lines.map(line => line.htmlElement?.outerHTML).reduce((acc, value) => acc += value + "\n", "") +
            `<script>const ${wrapperDivId}=document.getElementById("${this.wrapperDiv.id}_lineDrawingWrapper");function lineLength(e){let t=${wrapperDivId}.parentElement.getBoundingClientRect(),i=t.width/e.dataset.baseWidth,n=t.height/e.dataset.baseHeight;return Math.sqrt(Math.pow(e.dataset.x2*i-e.dataset.x1*i,2)+Math.pow(e.dataset.y2*n-e.dataset.y1*n,2))}function resizeLines(){Array.from(${wrapperDivId}.querySelectorAll(".lineDrawingLine")).forEach(e=>{e.style.width=lineLength(e) + "px"})}new ResizeObserver(resizeLines).observe(${wrapperDivId}.parentElement);</script>\n` +
            `</div>`;
    }
}

/**
 * Object representing a line inside a html element
 */
class Line {
    /**
     * 
     * @param {Number} strokeWidth - Width of the stoke for the line
     * @param {String} strokeColor - Color of the stroke for the line in css term
     */
    constructor(strokeWidth, strokeColor) {
        /**Starting point
         * @type {Vec2d|null}*/
        this.p1 = null;
        /**End point
         * @type {Vec2d|null} */
        this.p2 = null;
        /** Width of the stoke for the line*/
        this.strokeWidth = strokeWidth;
        /**  Color of the stroke for the line in css term*/
        this.strokeColor = strokeColor;
        /**HtmlElement representing the line inside the wrapper element
         * @type {HTMLDivElement|null} */
        this.htmlElement = null;
    }

    /**
     * @param {HTMLDivElement} wrapperDiv - Relative positioned div containing the lines that will be used for percent sizing
     * @returns 
     */
    getHtmlElementLine(wrapperDiv) {
        let p1 = this.p1;
        let p2 = this.p2;
        if (!this.p1) return;
        //If there is only one point then make the second point the same position as first point
        else if (!this.p2) {
            p2 = p1;
        }
        if (p1 && p2) {
            p1 = new Vec2d(p1.x, p1.y)
            p2 = new Vec2d(p2.x, p2.y)

            const degree = (Math.atan2(p1.y - p2.y, p1.x - p2.x) + Math.PI) * 360.0 / (2.0 * Math.PI);

            //Quadrant after splitting circle in 4 90 degrees section
            // const quadrant = Math.ceil(degree / 45);
            // const degreeInQuadrant = degree % 45;
            // if (quadrant == 1 || quadrant == 8) {
            //     p1.x -= this.strokeWidth/2;
            // }
            // else if (quadrant == 2 || quadrant == 3) {
            //     p1.y -= this.strokeWidth/2;
            // }
            // else if (quadrant == 4 || quadrant == 5) {
            //     p1.x += this.strokeWidth / 2;
            // }
            // else if (quadrant == 6 || quadrant == 7) {
            //     p1.y += this.strokeWidth / 2;
            // }

            // //How much degree inside the quadrant itself
            // const degreeInQuadrant = degree % 90;

            // let percentX;
            // let percentY;
            // //If it's the 1,3 quandrant
            // if(quadrant % 2 == 0){
            //     percentX= (degreeInQuadrant*100)/90;
            //     percentY = 100 - percentX;
            // }
            // else {
            //     percentY= (degreeInQuadrant*100)/90;
            //     percentX = 100 - percentY;
            // }
            // if (percentX > 100) percentX -= 100;
            // else if (percentX < 0) percentX += 100;
            // if (percentY > 100) percentY -= 100;
            // else if (percentY < 0) percentY += 100;

            //const originCenteredP2 = p2.getSubstractVec(p1);

            //const percentBasePoint = new Vec2d(((originCenteredP2.x / wrapperRect.width) * 100), ((originCenteredP2.y / wrapperRect.height) * 100));

            //const p2Percent = new Vec2d((originCenteredP2.x*100)/percentX,(originCenteredP2.y*100)/percentY);

            const wrapperRect = wrapperDiv.getBoundingClientRect();
            const lineLength = Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));

            const lineElement = document.createElement("div");
            lineElement.dataset.x1 = p1.x.toString();
            lineElement.dataset.y1 = p1.y.toString();
            lineElement.dataset.x2 = p2.x.toString();
            lineElement.dataset.y2 = p2.y.toString();
            lineElement.dataset.baseWidth = wrapperRect.width.toString();
            lineElement.dataset.baseHeight = wrapperRect.height.toString();
            lineElement.className = "lineDrawingLine";
            lineElement.style.transformOrigin = "center left";
            lineElement.style.transform = "rotate(" + degree + "deg)";
            lineElement.style.width = lineLength + "px";
            lineElement.style.height = this.strokeWidth + "px";
            lineElement.style.background = this.strokeColor;
            lineElement.style.position = "absolute";
            lineElement.style.top = ((p1.y / wrapperRect.height) * 100) + "%";
            lineElement.style.left = ((p1.x / wrapperRect.width) * 100) + "%";

            return lineElement;
        }
    }
}

/**
 * Object reprensenting a point or a 2d vector
 */
class Vec2d {
    /**
     * @param {Number} x 
     * @param {Number} y 
     */
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }

    /**
     * Returns a resulting vector of a substraction
     * @param {Vec2d} vec2 
     * @returns The result of the substraction
     */
    getSubstractVec(vec2) {
        return new Vec2d(this.x - vec2.x, this.y - vec2.y)
    }

    /**
     * Get the distance between 2 points
     * @param {Vec2d} vec2 
     */
    getDistance(vec2) {
        return Math.hypot((this.x - vec2.x), (this.y - vec2.y));
    }
}

function uuidv4() {
    return "a" + "10000000_1000_4000_8000_100000000000".replace(/[018]/g, c =>
      (parseInt(c) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> parseInt(c) / 4).toString(16)
    );
}